import { render, staticRenderFns } from "./NewConsult.vue?vue&type=template&id=04df190f&scoped=true&"
import script from "./NewConsult.vue?vue&type=script&lang=js&"
export * from "./NewConsult.vue?vue&type=script&lang=js&"
import style0 from "./NewConsult.vue?vue&type=style&index=0&id=04df190f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df190f",
  null
  
)

export default component.exports